// This file is auto-generated. Do not edit directly.
// This was last generated at 2026-07-01 06:43:12

export type Permission =
	| "account:read"
	| "account:update"
	| "apikeys:create"
	| "apikeys:delete"
	| "apikeys:read"
	| "apikeys:update"
	| "billing:delete"
	| "billing:read"
	| "billing:update"
	| "members:create"
	| "members:delete"
	| "members:read"
	| "members:update"
	| "notifications:create"
	| "notifications:delete"
	| "notifications:read"
	| "notifications:update"
	| "security:read"
	| "security:update"
	| "tools:read"
	| "tools:write";

export type Role = "Member" | "Owner" | "Admin" | "Billing";

/** Every RBAC permission slug. */
export const ALL_PERMISSIONS = [
	"account:read",
	"account:update",
	"apikeys:create",
	"apikeys:delete",
	"apikeys:read",
	"apikeys:update",
	"billing:delete",
	"billing:read",
	"billing:update",
	"members:create",
	"members:delete",
	"members:read",
	"members:update",
	"notifications:create",
	"notifications:delete",
	"notifications:read",
	"notifications:update",
	"security:read",
	"security:update",
	"tools:read",
	"tools:write",
] as const satisfies readonly Permission[];

/** modules.yaml gate per permission (omitted = core, always available). */
export const PERMISSION_MODULES: Partial<Record<Permission, string>> = {
	"apikeys:create": "public_api",
	"apikeys:delete": "public_api",
	"apikeys:read": "public_api",
	"apikeys:update": "public_api",
	"billing:delete": "billing",
	"billing:read": "billing",
	"billing:update": "billing",
	"members:create": "team",
	"members:delete": "team",
	"members:read": "team",
	"members:update": "team",
	"notifications:create": "notifications",
	"notifications:delete": "notifications",
	"notifications:read": "notifications",
	"notifications:update": "notifications",
	"security:read": "operations",
	"security:update": "operations",
	"tools:read": "public_api",
	"tools:write": "public_api",
};

interface RolePermissionMapping {
	role: Role;
	permissions: Permission[];
}

const rolePermissionMappings: RolePermissionMapping[] = [
	{
		role: "Owner",
		permissions: [
			"account:read",
			"account:update",
			"apikeys:create",
			"apikeys:delete",
			"apikeys:read",
			"apikeys:update",
			"billing:delete",
			"billing:read",
			"billing:update",
			"members:create",
			"members:delete",
			"members:read",
			"members:update",
			"notifications:create",
			"notifications:delete",
			"notifications:read",
			"notifications:update",
			"security:read",
			"security:update",
		],
	},
	{
		role: "Admin",
		permissions: [
			"account:read",
			"account:update",
			"apikeys:create",
			"apikeys:delete",
			"apikeys:read",
			"apikeys:update",
			"billing:delete",
			"billing:read",
			"billing:update",
			"members:create",
			"members:delete",
			"members:read",
			"members:update",
			"notifications:create",
			"notifications:delete",
			"notifications:read",
			"notifications:update",
			"security:read",
			"security:update",
		],
	},
	{
		role: "Billing",
		permissions: [
			"account:read",
			"billing:delete",
			"billing:read",
			"billing:update",
		],
	},
	{
		role: "Member",
		permissions: [
			"account:read",
			"apikeys:read",
			"billing:read",
			"members:read",
		],
	},
];

/**
 * Checks if a given role has a specific permission
 * @param role The role to check
 * @param permission The permission to verify
 * @returns boolean indicating if the role has the permission
 */
function hasPermission(role: Role, permission: Permission): boolean {
	if (!role || !permission) {
		return false;
	}
	const mapping = rolePermissionMappings.find(
		(m) => m.role.toLowerCase() === role.toLowerCase(),
	);
	if (!mapping) {
		return false;
	}
	return mapping.permissions.includes(permission);
}

export { hasPermission };
